module.exports = __webpack_public_path__ + "img/icon-supplemental-audio.c5c1ec34.svg";